import { Button, FormHelperText, MenuItem, Select, Stack } from '@mui/material';
import { FlowDynamicValueType } from 'flow-schema';
import { useId } from 'react';

import { FormField, api } from 'common';

import { type ScriptContextType } from './ScriptContext';
import { createDynamicValue, getDynamicValueTypeOptions } from './utils';
import { FeatureFlagKey, useFlag } from '../../../../../../../utils/flags';

import DynamicValue = api.FlowDefinition.DynamicValue;

interface BlockDynamicFieldPlaceholderProps {
  description?: string;
  scriptContextType?: ScriptContextType;
  onCreate: (value: DynamicValue) => void;
}

export function BlockDynamicFieldPlaceholder(props: BlockDynamicFieldPlaceholderProps) {
  const { description, scriptContextType, onCreate } = props;
  const flowInputAutoTypeOptions = useFlag({ flagKey: FeatureFlagKey.flowInputAutoTypeOptions });
  const typeOptions = getDynamicValueTypeOptions({
    scriptContextType,
    isAutoDynamicValueTypeEnabled: flowInputAutoTypeOptions.isEnabled,
  });
  const fieldId = useId();
  return (
    <Stack gap={1}>
      <FormHelperText>{description}</FormHelperText>
      <FormField id={fieldId} label="Type">
        {typeOptions ? (
          <Select
            aria-label="Input Type"
            size="small"
            fullWidth
            onChange={(event) => {
              const newType = (event.target.value as FlowDynamicValueType | '') || undefined;
              if (newType) {
                onCreate(createDynamicValue(newType));
              }
            }}
          >
            {typeOptions.map(({ value, label, helperText }) => (
              <MenuItem key={value} value={value}>
                <Stack>
                  <span>{label}</span>
                  <FormHelperText>{helperText}</FormHelperText>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Button onClick={() => onCreate(createDynamicValue(FlowDynamicValueType.Auto))}>
            + Add
          </Button>
        )}
      </FormField>
    </Stack>
  );
}
